import { render, staticRenderFns } from "./PageMenuPriceSettings.vue?vue&type=template&id=d1cb6ede&scoped=true&"
import script from "./PageMenuPriceSettings.vue?vue&type=script&lang=ts&"
export * from "./PageMenuPriceSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PageMenuPriceSettings.vue?vue&type=style&index=0&id=d1cb6ede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cb6ede",
  null
  
)

export default component.exports